import { styled, css } from 'styled-components';
import { theme } from '../../../../constants/theme.mjs';
import { HEADER_HEIGHT } from '../../Header.styles.mjs';
"use strict";
const HEADER_NAVIGATION_CAROUSEL_HEIGHT = 92;
const HEADER_NAVIGATION_CAROUSEL_STICKY_TRANSITION_OFFSET = HEADER_NAVIGATION_CAROUSEL_HEIGHT - HEADER_HEIGHT;
const ITEMS_GAP = 50;
const ITEM_MIN_WIDTH = 44;
const ITEM_IMAGE_WRAP_HEIGHT = 38;
const ItemsInnerWrap = styled.div`
  width: 100%;
  gap: ${ITEMS_GAP}px;

  > div {
    padding: 0 ${ITEMS_GAP / 2}px;
  }
`;
const ImageWrap = styled.div`
  height: ${ITEM_IMAGE_WRAP_HEIGHT}px;
  width: auto;
  display: flex;
  /* Previously editable via center or flex-end */
  align-items: flex-end;
  margin-bottom: 9px;

  transition:
    opacity 0.2s ease-in-out,
    transform 0.2s ease-in-out;

  svg {
    max-height: 100%;

    * {
      transition: fill 0.2s ease-in-out;
    }
  }
`;
const IconLabelWrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 0;
  transition: gap 0.2s ease-in-out;
  ${({
  $sticky
}) => $sticky && css`
      gap: 6px;
    `}
`;
const SmallIconWrap = styled.div`
  height: ${({
  $height
}) => $height}px;
  width: 0;
  overflow: hidden;
  opacity: 0;
  transition:
    opacity 0.2s ease-in-out,
    flex 0.2s ease-in-out;
  flex: 0;
  ${({
  $sticky
}) => $sticky && css`
      opacity: 1;
      flex: 1;
      width: auto;
    `}
`;
const Label = styled.div`
  position: relative;
  height: 27px;

  ${({
  $sticky,
  $horizontalPlacement
}) => $sticky && $horizontalPlacement && css`
      display: flex;
      align-items: flex-end;
      gap: 6px;

      ${SubLabel} {
        margin-top: 0;
        line-height: 1.12;
      }
    `}
`;
const SubLabel = styled.div`
  color: ${({
  $motif,
  $blue
}) => $blue ? theme.colors.primaryBlue : theme.colors.menu.textAccent[$motif]};
  font-size: ${theme.font.size10};
  line-height: 1.2;
  margin-top: 3px;
`;
const ItemAnchor = styled.a`
  padding: 10px 0 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  text-align: center;
  color: ${({
  $motif
}) => $motif === "dark" ? "#D9D9D9" : "#494949"};
  font-size: ${theme.font.size12};
  line-height: 1;
  position: relative;
  transition: color 0.2s ease-in-out;

  min-width: ${ITEM_MIN_WIDTH}px;

  ${({
  $showUnderline
}) => $showUnderline && css`
      box-shadow: inset 0 -1px 0 0 ${theme.colors.primaryBlue};
    `}

  &:hover {
    color: ${({
  $motif
}) => theme.colors.menu.active[$motif]};

    ${ImageWrap} {
      ${({
  $motif
}) => css`
        color: ${theme.colors.menu.categoryIconActive[$motif]};
      `}
    }
  }

  ${({
  $motif,
  $active
}) => $active && css`
      color: ${theme.colors.menu.active[$motif]};

      ${ImageWrap} {
        color: ${theme.colors.menu.categoryIconActive[$motif]} !important;
      }
    `}
`;
const ItemsWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  ${({
  $showUnderline
}) => $showUnderline && css`
      box-shadow: inset 0 -1px 0 0 #d9d9d9;
    `}

  ${({
  $sticky,
  $stickyHeader
}) => $sticky && css`
      position: fixed;
      top: ${$stickyHeader ? HEADER_HEIGHT : 0}px;

      ${ImageWrap} {
        opacity: 0;
        margin: 0;
        margin-top: ${-ITEM_IMAGE_WRAP_HEIGHT}px;
        width: auto;
        transform: translateY(-10px);
      }

      ${Label} {
        height: 100%;
      }
    `}
`;
const Wrap = styled.div`
  position: relative;
  z-index: ${theme.zIndex.mobileMenu - 1};
  background: ${({
  $motif
}) => theme.colors.menu.base[$motif]};
  display: flex;
  justify-content: center;
  align-items: center;

  /* Container stays the same height */
  height: ${HEADER_NAVIGATION_CAROUSEL_HEIGHT}px;

  ${({
  $sticky
}) => $sticky && css`
      ${ItemsWrap} {
        /* Items become header height */
        height: ${HEADER_HEIGHT}px;
      }
    `}

  ${ImageWrap} {
    ${({
  $motif
}) => css`
      color: ${theme.colors.menu.categoryIcon[$motif]};
    `}
  }

  ${ItemsWrap} {
    background: inherit;
  }
`;
export { HEADER_NAVIGATION_CAROUSEL_HEIGHT, HEADER_NAVIGATION_CAROUSEL_STICKY_TRANSITION_OFFSET, IconLabelWrap, ImageWrap, ItemAnchor, ItemsInnerWrap, ItemsWrap, Label, SmallIconWrap, SubLabel, Wrap };
//# sourceMappingURL=Carousel.styles.mjs.map
